import { render, staticRenderFns } from "./TransactionListComponent.vue?vue&type=template&id=459a15ae"
import script from "./TransactionListComponent.vue?vue&type=script&lang=js"
export * from "./TransactionListComponent.vue?vue&type=script&lang=js"
import style0 from "./TransactionListComponent.vue?vue&type=style&index=0&id=459a15ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports